module.exports = __webpack_public_path__ + "img/473.4f10a1b0.jpg";